export const exportData = async (response: Response, isPdf?: boolean) => {
  if (response.ok) {
    const url = window.URL.createObjectURL(await response.blob());
    const a = document.createElement('a');
    a.href = url;
    a.download = isPdf ? 'report' : 'exported_data';
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  return null;
};
